<template>
  <div :class="isFocus ? 'hf focus' : 'hf'">
    <div class="fl hf mb-1">
      <p class="label hf" v-if="label">{{ label }}</p>
      <p class="optional" v-if="optional">({{ 'optional' | translate }})</p>
    </div>

    <div class="fl hf" style="height: 50px;">
      <select
        :value="value"
        @input="updateValue()"
        @change="emitChange()"
        @blur="isFocus = false"
        @focus="isFocus = true"
        :placeholder="this.placeholder"
        :class="getTextFieldClass()"
        :style="this.getStyle()"
        ref="TextField"
      >
        <slot name="default" />
      </select>
      <div :class="getSlotLeftClass()" v-if="hasLeftSlot">
        <slot name="icon" :class="getSlotLeftClass()"></slot>
      </div>
    </div>

    <div v-if="shouldShowErrors">
      <p
        v-for="(error, index) in this.errors"
        :key="index"
        :style="getErrorsStyle()"
        class="validation-warning"
      >{{error | translate}}</p>
    </div>
  </div>
</template>

<script>
import _ from "lodash";

export default {
  name: "dropdown",
  props: {
    optional: Boolean,
    label: String,
    placeholder: String,
    right: Boolean,
    left: Boolean,
    center: Boolean,
    value: null,
    errors: null
  },
  data() {
    return {
      shouldShowErrors: true,
      isFocus: false
    };
  },
  computed: {
    hasLeftSlot() {
      return !!this.$slots["icon"];
    }
  },
  methods: {
    updateValue() {
      this.shouldShowErrors = false;
      this.$emit("input", this.$refs.TextField.value);
      if (this.value == null) {
        this.$refs.TextField.value = null;
      } else {
        this.$refs.TextField.value = this.value;
      }
    },

    emitChange() {
      this.shouldShowErrors = true;
      this.$emit("change", this.$refs.TextField.value);
      this.$refs.TextField.value = this.value;
    },

    getStyle() {
      let result = "";
      if (this.hasLeftSlot) {
        result +=
          "border-top-left-radius: 5px; border-bottom-left-radius: 5px;";
      }
      if (this.right) result += "text-align: right;";
      if (this.left) result += "text-align: left;";
      if (this.center) result += "text-align: center;";
      return result;
    },
    getSlotLeftClass() {
      if (!_.isEmpty(this.errors) && this.shouldShowErrors)
        return "slot invalid";
      else return "slot";
    },

    getTextFieldClass() {
      if (!_.isEmpty(this.errors) && this.shouldShowErrors)
        return "text-field invalid";
      else return "text-field";
    },

    getErrorsStyle() {
      if (this.right) {
        return "text-align: right;";
      } else if (this.left) {
        return "text-align: left;";
      } else if (this.center) {
        return "text-align: center;";
      } else {
        return "text-align: left;";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../utils/assets/stylesheets/variables.scss";

.focus {
  .text-field {
    border: 1px solid $secondary-lighten-3;
    color: $secondary;
  }

  .slot-left {
    border: 1px solid $secondary-lighten-3;
    background-color: $secondary-lighten-4;
    border-right: 0;
    color: $secondary;

    .theme--light.v-icon {
      color: $secondary;
    }
    p {
      color: $secondary;
    }
  }
}

select {
  option {
    background-color: white;
    border: 0;
    border: 1px solid $secondary-lighten-1;
    color: $primary;

    &:hover {
      box-shadow: inset 0 0 20px 200px $primary;
    }

    &:checked {
      box-shadow: inset 0 0 20px 200px $primary;
    }
  }
}

.text-field {
  background-color: white;
  box-sizing: border-box;
  border: 1px solid $gray-lighten-1;
  border-radius: $border-radius;

  height: 100%;
  padding: 0px 15px;

  width: 100%;
  outline: none;
  font-weight: 500;
  letter-spacing: 0.1px;
  color: $primary;
  font-size: 1em;

  transition: all 200ms cubic-bezier(0.21, 1.05, 0.83, 0.67);

  &::placeholder {
    color: rgb(179, 185, 206);
    font-weight: 400;
    font-size: 1em !important;
  }

  &.invalid {
    border: 1px solid $error-lighten-2;
    color: $error;
  }
}

.slot {
  background-color: $gray-lighten-2;
  border: 1px solid $gray-lighten-2;
  border-left: 0;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  height: 100%;
  padding: 0px 17px;
  color: $primary;
  text-align: center;

  p {
    color: $primary;
    font-size: 1.1em;
    font-weight: 700;
    top: 50%;
    min-width: 17px;
    position: relative;
    transform: translateY(-50%);
  }

  &.invalid {
    background-color: $error-lighten-1;
    color: $error;
    border: 1px solid #ffcdd5;
    border-right: 0;

    .theme--light.v-icon {
      color: $error;
    }

    p {
      color: $error;
    }
  }
}

.validation-warning {
  color: $error;
  padding-top: 7px;
  font-size: 0.9em;
}

.theme--light.v-icon {
  color: $primary;
  top: 50%;
  position: relative;
  transform: translateY(-50%);
  font-size: 1.3em;
}

.label {
  color: $primary-lighten-1;
}

.optional {
  color: $primary-lighten-2;
  font-size: 0.8em;
}
</style>
